import { render, staticRenderFns } from "./SystemMessageAdd.vue?vue&type=template&id=4a66f51d&"
import script from "./SystemMessageAdd.vue?vue&type=script&lang=js&"
export * from "./SystemMessageAdd.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports